import React from 'react'
import styles from './LogoStrip.module.css'

import Siddhivinayak from '../../assets/Siddhivinayak.png'
import Veraco from '../../assets/veraco.png'
import VSGGroup from '../../assets/vsggroup.png'
import kailash from '../../assets/kailash-properties.png'

const logos = [
  { src: VSGGroup, name: 'VSG Group' },
  { src: kailash, name: 'Kailash-Properties' },
  { src: Veraco, name: 'Veraco' },
  { src: Siddhivinayak, name: 'Siddhivinayak' },
]

const LogoStrip = () => {
  return (
    <div className={styles.wrapper}>
      <p className={styles.label}>ASSOCIATED WITH</p>
      <div className={styles.strip}>
        {logos.map((logo, i) => (
          <React.Fragment key={i}>
            <div className={styles.logoBox}>
              <img src={logo.src} alt={logo.name} className={styles.logoImg} />
            </div>
            {i < logos.length - 1 && <div className={styles.divider} />}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default LogoStrip